import { GoogleLogin, GoogleLogout } from 'react-google-login';
import {LOGIN_URL, TOKEN, SET_COOKIE, GOOGLE_LOGIN_URL, GET_USER_URL, UPLOAD_GOOGLE_LOGIN_URL, UPLOAD_PICXY_URL_REDIRECT } from '../vars'
import {setLocalKeyValue, getLocalKeyValue, getSessionKeyValue} from '../storage'
import { withRouter } from 'next/router'
import {GET, POST, UPOST} from '../helpers'


export default class SOCIAL_GOOGLE_LOGIN extends React.Component {


  constructor(){
    super()
    this.state = { gle_login_success:false, gle_login_processing:false }
  }

  loginGoogleError = (res)=>{
      console.log(res);
  }

  loginGoogleSuccess = (res)=>{

    let login_type = this.props.login_page

    this.setState({gle_login_processing:true})

    let url = GOOGLE_LOGIN_URL
    if (login_type == "upload_login"){
      url = UPLOAD_GOOGLE_LOGIN_URL
    }

    UPOST(url, {token: res.tokenId}).then((response)=>{
      let token = response.data.token
      if(token) {
        if (login_type == "upload_login") {
          window.open(UPLOAD_PICXY_URL_REDIRECT+token, "_self");
        }
        else {
          setLocalKeyValue(TOKEN, token)
          document.cookie = "token="+token + ";path=/;"
          this.setState({gle_login_success:true})
          if(getSessionKeyValue('referer')) {
              let ref = getSessionKeyValue('referer')
              sessionStorage.removeItem('referer')
              window.location.href = ref
          }
          else {
              window.location.href = "/"
          }
        }
      }

    })
  }

  render() {
          let btnName = this.props.name || "Login With Google"
          let gleLogin =   <div className="text-center">
            <GoogleLogin
             clientId="236256381920-6jij29hebh6m2fnr563dvu4f8aerokf1.apps.googleusercontent.com"
             buttonText={btnName}
             style={{boxShadow:'none', textAlign:'center'}}
             className={"justify-content-center d-flex btn-block "}
             onSuccess={this.loginGoogleSuccess}
             onFailure={this.loginGoogleError}
             cookiePolicy={'single_host_origin'}
           />
           <div className="mt-4">
             <hr className="hr-text" data-content="or"/>
           </div>
          </div>

        if(this.state.gle_login_processing) {
          gleLogin = <div className="d-flex justify-content-center">
                      <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                      </div>
                    </div>

        }

        return <div>{gleLogin}</div>

  }
}
